import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-inputs" }
const _hoisted_2 = { class: "form-buttons" }
const _hoisted_3 = { class: "left-buttons" }
const _hoisted_4 = { class: "right-buttons" }
const _hoisted_5 = { class: "left-buttons" }
const _hoisted_6 = { class: "right-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NcTextField = _resolveComponent("NcTextField")!
  const _component_NcButton = _resolveComponent("NcButton")!
  const _component_AccountMultiplePlus = _resolveComponent("AccountMultiplePlus")!
  const _component_XLoadingIcon = _resolveComponent("XLoadingIcon")!
  const _component_Send = _resolveComponent("Send")!
  const _component_AlbumCollaborators = _resolveComponent("AlbumCollaborators")!

  return (!_ctx.showCollaboratorView)
    ? (_openBlock(), _createElementBlock("form", {
        key: 0,
        class: "album-form",
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_NcTextField, {
            ref: "nameInput",
            type: "text",
            name: "name",
            autofocus: "true",
            modelValue: _ctx.albumName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.albumName) = $event)),
            required: true,
            label: _ctx.t('memories', 'Album Name'),
            "label-visible": true,
            placeholder: _ctx.t('memories', 'Album Name')
          }, null, 8, ["modelValue", "label", "placeholder"]),
          _createVNode(_component_NcTextField, {
            name: "location",
            type: "text",
            modelValue: _ctx.albumLocation,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.albumLocation) = $event)),
            label: _ctx.t('memories', 'Location'),
            "label-visible": true,
            placeholder: _ctx.t('memories', 'Location of the album')
          }, null, 8, ["modelValue", "label", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            (_ctx.displayBackButton)
              ? (_openBlock(), _createBlock(_component_NcButton, {
                  key: 0,
                  "aria-label": _ctx.t('memories', 'Go back to the previous view.'),
                  variant: "tertiary",
                  onClick: _ctx.back
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('memories', 'Back')), 1)
                  ]),
                  _: 1
                }, 8, ["aria-label", "onClick"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("span", _hoisted_4, [
            (_ctx.sharingEnabled && !_ctx.editMode)
              ? (_openBlock(), _createBlock(_component_NcButton, {
                  key: 0,
                  "aria-label": _ctx.t('memories', 'Go to the add collaborators view.'),
                  variant: "secondary",
                  disabled: _ctx.albumName.trim() === '' || _ctx.loading,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showCollaboratorView = true))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_AccountMultiplePlus)
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'Add collaborators')), 1)
                  ]),
                  _: 1
                }, 8, ["aria-label", "disabled"]))
              : _createCommentVNode("", true),
            _createVNode(_component_NcButton, {
              "aria-label": _ctx.saveText,
              variant: "primary",
              disabled: _ctx.albumName === '' || _ctx.loading,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submit()))
            }, {
              icon: _withCtx(() => [
                (_ctx.loading)
                  ? (_openBlock(), _createBlock(_component_XLoadingIcon, { key: 0 }))
                  : (_openBlock(), _createBlock(_component_Send, { key: 1 }))
              ]),
              default: _withCtx(() => [
                _createTextVNode(" " + _toDisplayString(_ctx.saveText), 1)
              ]),
              _: 1
            }, 8, ["aria-label", "disabled"])
          ])
        ])
      ], 32))
    : (_openBlock(), _createBlock(_component_AlbumCollaborators, {
        key: 1,
        "album-name": _ctx.albumName,
        "allow-public-link": false,
        collaborators: []
      }, {
        default: _withCtx(({ collaborators }) => [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_NcButton, {
              "aria-label": _ctx.t('memories', 'Back to the new album form.'),
              variant: "tertiary",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showCollaboratorView = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('memories', 'Back')), 1)
              ]),
              _: 1
            }, 8, ["aria-label"])
          ]),
          _createElementVNode("span", _hoisted_6, [
            _createVNode(_component_NcButton, {
              "aria-label": _ctx.saveText,
              variant: "primary",
              disabled: _ctx.albumName.trim() === '' || _ctx.loading,
              onClick: ($event: any) => (_ctx.submit(collaborators))
            }, {
              icon: _withCtx(() => [
                (_ctx.loading)
                  ? (_openBlock(), _createBlock(_component_XLoadingIcon, { key: 0 }))
                  : (_openBlock(), _createBlock(_component_Send, { key: 1 }))
              ]),
              default: _withCtx(() => [
                _createTextVNode(" " + _toDisplayString(_ctx.saveText), 1)
              ]),
              _: 1
            }, 8, ["aria-label", "disabled", "onClick"])
          ])
        ]),
        _: 1
      }, 8, ["album-name"]))
}